/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */

import {TSBegruendungsCode} from './enums/TSBegruendungsCode';
import {TSErfassungsArt} from './enums/TSErfassungsArt';
import {TSRole} from './enums/TSRole';
import {TSSchadenfallEvent} from './enums/TSSchadenfallEvent';
import {TSSchadenfallStatus} from './enums/TSSchadenfallStatus';

export default class TSStatuswechsel {

    private readonly _status: TSSchadenfallStatus;
    private readonly _begruendungscodeOptions: Map<TSSchadenfallEvent, Array<TSBegruendungsCode>>;
    private readonly _checklistOptions: Array<string>;
    private readonly _possibleEvents: Array<TSSchadenfallEvent>;
    private readonly _allowedRoles: Array<TSRole>;
    private readonly _visibleOnPage: string;
    private readonly _allowedErfassungsArt: Array<TSErfassungsArt>;

    constructor(status: TSSchadenfallStatus, begruendungscodeOptions: Map<TSSchadenfallEvent, Array<TSBegruendungsCode>>,
                checklistOptions: Array<string>,
                possibleEvents: Array<TSSchadenfallEvent>,
                allowedRoles: Array<TSRole>, visibleOnPage: string, allowedErfassungsArt: Array<TSErfassungsArt>) {
        this._status = status;
        this._begruendungscodeOptions = begruendungscodeOptions;
        this._checklistOptions = checklistOptions;
        this._possibleEvents = possibleEvents;
        this._allowedRoles = allowedRoles;
        this._visibleOnPage = visibleOnPage;
        this._allowedErfassungsArt = allowedErfassungsArt;
    }

    public get status(): TSSchadenfallStatus {
        return this._status;
    }

    public get checklistOptions(): Array<string> {
        return this._checklistOptions;
    }

    public get possibleEvents(): Array<TSSchadenfallEvent> {
        return this._possibleEvents;
    }

    public get allowedRoles(): Array<TSRole> {
        return this._allowedRoles;
    }

    public get visibleOnPage(): string {
        return this._visibleOnPage;
    }

    public get allowedErfassungsArt(): Array<TSErfassungsArt> {
        return this._allowedErfassungsArt;
    }

    get begruendungscodeOptions(): Map<TSSchadenfallEvent, Array<TSBegruendungsCode>> {
        return this._begruendungscodeOptions;
    }

    public readBegruendungscodeOptions(event: TSSchadenfallEvent): Array<TSBegruendungsCode> {
        let allowedBegruendungscodes = this._begruendungscodeOptions.get(event);
        return allowedBegruendungscodes || [];
    }
}



// WEBPACK FOOTER //
// ./src/app/models/TSStatuswechsel.ts